import { LitElement, render } from 'lit';

export const renderToDom = (comp : LitElement) : HTMLElement => {
  const host = document.createElement('div');
  // @ts-expect-error "Is public anyway"
  render(comp.render(), host);
  return host;
};
